import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { LocalStorageService } from "./storage-service/local-storage.service";
import { BehaviorSubject, Observable, of } from "rxjs";
import { NAVIGATE_ROUTES } from "../global/constants";
import { ApiService } from "./api-service/api.service";

@Injectable({
  providedIn: "root",
})
export class UserDetailsService {
  getToken: any;
  decrypt: any;
  userId: any;
  encryptUserId: any;
  userImg: any;
  updateUserImg = new BehaviorSubject<any>("");
  updateUserName = new BehaviorSubject<any>({});
  updateCompanyList = new BehaviorSubject<any>("");
  decryptSelectedCompanyId: any;
  apiEndPoint = NAVIGATE_ROUTES;
  res: any = [];
  userRolePermission: any = {};

  // Decode JWT payload without extra dependency
  private decodeAuthToken(): any {
    try {
      const token = localStorage.getItem("authorization");
      if (!token || typeof token !== "string" || !token.includes(".")) {
        return null;
      }
      const payload = token.split(".")[1];
      const padded = payload.padEnd(payload.length + (4 - (payload.length % 4)) % 4, "=");
      const base64 = padded.replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(atob(base64));
    } catch (_e) {
      return null;
    }
  }

  constructor(private ls: LocalStorageService, private apiService: ApiService) {
    this.getToken = localStorage.getItem("token");
    this.encryptUserId = this.getToken;
    if (this.getToken) {
      this.decrypt = CryptoJS.AES.decrypt(this.getToken?.trim(), "").toString(
        CryptoJS.enc.Utf8
      );
    }
    this.userId = parseInt(this.decrypt);
  }
  async getUserName() {
    return await this.ls.getDataFromIndexedDB("username");
  }

  async getCompanyId() {
    return await this.ls.getDataFromIndexedDB("companyId");
  }

  async getCompanyFileSize() {
    return await this.ls.getDataFromIndexedDB("companyIdFileSize");
  }

  async getUserImagePath() {
    return this.normalizeProfileImagePath(
      await this.ls.getDataFromIndexedDB("userimagepath")
    );
  }

  async getUserEmail() {
    return await this.ls.getDataFromIndexedDB("email");
  }
  async getUserMobileNumber() {
    return await this.ls.getDataFromIndexedDB("mobileNumber");
  }

  async editUser(newUserImgPath: any) {
    await this.updateUserImg.next(this.normalizeProfileImagePath(newUserImgPath));
  }

  async getSelectedCompanyId() {
    return await this.ls.getDataFromIndexedDB("selectedCompanyId");
  }

  async getSelectedCompanyFileSize() {
    return await this.ls.getDataFromIndexedDB("selectedCompanyFileSize");
  }

  async getSelectedCompanyName() {
    return await this.ls.getDataFromIndexedDB("selectedCompanyName");
  }

  async editUserName(newUserName: any) {
    await this.updateUserName.next(newUserName);
  }

  async getUpdatePlanState() {
    return await this.ls?.getDataFromIndexedDB("updateState");
  }

  async getUpdatedCompanyList(boolean: boolean) {
    await this.updateCompanyList.next(boolean);
  }

  async getUserRolePermissions() {
    return await this.ls?.getDataFromIndexedDB("userRolePermission");
  }

  async getUserRolePermission(userId: any, companyId: any) {
    this.res = [];
    let userRolePermission: any = {};
    if (companyId) {
      const url = `${this.apiEndPoint.COMPANY}/userCompanyAccesses?companyId=${companyId}&userId=${userId}`;
      await this.apiService.get(url).then(async (data: any) => {
        if (data) {
          userRolePermission = data?.role?.rolePermission
            ? data?.role?.rolePermission
            : {};
          userRolePermission["permissions"] = data?.permissions;
          userRolePermission["memberId"] = data?.member_id;
          userRolePermission["superAdmin"] = data?.superAdmin;
          userRolePermission["owner"] = data?.owner;
          userRolePermission["is_head"] = data?.is_head;
          await this.ls.setDataInIndexedDB(
            "userRolePermission",
            userRolePermission
          );
        }
      });
      return userRolePermission;
    }
  }

  async getSelectedCompanyData() {
    return await this.ls?.getDataFromIndexedDB("selectedCompanyData");
  }

  async getLoginUserData() {
    const loginUserData: any = await this.ls?.getDataFromIndexedDB(
      "loginUserData"
    );
    if (loginUserData?.profile_image) {
      loginUserData.profile_image = this.normalizeProfileImagePath(
        loginUserData.profile_image
      );
    }
    return loginUserData;
  }
  async getPresignURL(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.PRESIGN_URL}`;
    await this.apiService.post(url, { files: data }).then((resData: any) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async s3MediaUpload(url: string, file: File): Promise<Observable<any>> {
    this.res = [];
    const headers = {
      "Content-Type": file.type,
    };
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: file,
    });

    if (response?.status == 200) {
      this.res = 200;
    } else {
      this.res = response;
    }
    return of(this.res);
  }

  decryptedCompanyId(company_id: any) {
    return parseInt(
      CryptoJS.AES.decrypt(company_id?.trim(), "").toString(CryptoJS.enc.Utf8)
    );
  }

  normalizeProfileImagePath(profileImage: any) {
    if (typeof profileImage !== "string") {
      return profileImage || "";
    }

    const normalizedPath = profileImage.trim().replace(/^['"]+|['"]+$/g, "");
    return normalizedPath;
  }
}
